import React from "react";
import { Marker } from "react-map-gl";
import Pinned from "../../images/lbs/active-pin.svg";
import Pin from "../../images/lbs/pin.svg";
import PropTypes from "prop-types";

const Markers = (props) => {
  const { Locations, ActivePin, setActivePin, changeMarkerImage } = props;

  const handleToggledPin = (id) => {
    setActivePin(id);
  };

  if (!Locations || Locations.length === 0) {
    return <span />;
  }

  return (
    <>
      {Locations.map((marker) => (
        <div
          key={marker.id}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Marker
            key={marker.title}
            longitude={marker.lng}
            latitude={marker.lat}
            offsetLeft={-20}
            offsetTop={-10}
          >
            <img
              name={marker.id}
              src={ActivePin === marker.id && changeMarkerImage ? Pinned : Pin}
              alt="pin"
              className="center-pin"
              width={
                ActivePin === marker.id && changeMarkerImage ? "45px" : "30px"
              }
              height={
                ActivePin === marker.id && changeMarkerImage ? "45px" : "30px"
              }
              onClick={(event) => handleToggledPin(marker.id)}
            />
          </Marker>
        </div>
      ))}
    </>
  );
};

Markers.propTypes = {
  Locations: PropTypes.array.isRequired,
  ActivePin: PropTypes.string.isRequired,
  setActivePin: PropTypes.func.isRequired,
  changeMarkerImage: PropTypes.bool.isRequired,
};

export default Markers;
